import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import CustomCard from "../../../components/CustomCard";
import { getCustomerRules } from "../../../services/customer";
import useAppSelector from "../../../hooks/useAppSelector";

import CompanyDetailsIcon from "../icons/CompanyDetails";
import ContactDetailsIcon from "../icons/ContactDetails";
import { updateTicketGroupContact } from "../../../services/ticketGroup";
import { toast } from "react-toastify";

const Customer = ({ customerInfo, affiliate, ticketGroup, customerContactId }) => {
  const { customerRules: mainCustomerRules } = useAppSelector(state => state.appData);
  const [customerRules, setCustomerRules] = useState([]);
  const [contactId, setContactId] = useState();

  useEffect(() => {
    setContactId(customerContactId);
  }, []);

  useEffect(() => {
    if (!customerInfo.id) {
      return;
    }
    getCustomerRules(customerInfo.id).then(setCustomerRules);
  }, [customerInfo.id]);

  const handleUpdateTicketGroupContact = async (id) => {
    try {
      await updateTicketGroupContact(ticketGroup.id, id);
      setContactId(id);
      toast.success("Contact updated successfully !!");
    } catch (err) {
      console.error(err);
      toast.error(
        "Failed to update contact, please contact administrator !!!"
      );
    }
  }

  return (
    <>
      {ticketGroup.addressedToOther && (
        <div className="mb-2">
          <CustomCard
            title={
              <>
                <ContactDetailsIcon />
                Addressed to
              </>
            }
          >
            {(ticketGroup.addressedToFirstName || ticketGroup.addressedToLastName) && <p>{ticketGroup.addressedToFirstName} {ticketGroup.addressedToLastName}</p>}
            {ticketGroup.addressedToEmail && <p>{ticketGroup.addressedToEmail}</p>}
            {ticketGroup.addressedToPhone && <p>{ticketGroup.addressedToPhone}</p>}
          </CustomCard>
        </div>
      )}
      {affiliate &&
        <div className="mb-2">
          <CustomCard
            title={
              <>
                <CompanyDetailsIcon />
                Partner
              </>
            }
          >
            {affiliate.companyName &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Company name (payable to)</p>
                <p>{affiliate.companyName}</p>
              </div>
            }
            {ticketGroup.affiliateInfo?.paymentMethod &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Saved Payment Method</p>
                <p>{ticketGroup.affiliateInfo?.paymentMethod}</p>
                <hr />
              </div>
            }
            {affiliate.referrerName &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Referrer name</p>
                <p>{affiliate.referrerName}</p>
              </div>
            }
            {affiliate.position &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Position</p>
                <p>{affiliate.position}</p>
              </div>
            }
            {affiliate.phoneNumber &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Phone number</p>
                <p>{affiliate.phoneNumber}</p>
              </div>
            }
            {affiliate.emailAddress &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Email address</p>
                <p>{affiliate.emailAddress}</p>
              </div>
            }
            {affiliate.streetAddress &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Street address (important for payment purposes)</p>
                <p>{affiliate.streetAddress}</p>
              </div>
            }
            {(affiliate.paymentMethod || affiliate.accountNumber || affiliate.routingNumber) &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Payment method + account & routing #</p>
                <p>{affiliate.paymentMethod ?? 'No payment method'} | Account: {affiliate.accountNumber ?? 'NA'} | Routing: {affiliate.routingNumber ?? 'NA'}</p>
              </div>
            }
            {affiliate.agreementAndW9OnFile &&
              <div className="mb-2">
                <p style={{ fontSize: 10, lineHeight: 1, margin: 0, color: '#a4a4a4' }}>Flag indicating agreement & W9 are on file</p>
                <p>{affiliate.agreementAndW9OnFile}</p>
              </div>
            }
          </CustomCard>
        </div>
      }
      <CustomCard
        title={
          <>
            <CompanyDetailsIcon />
            Company Details
          </>
        }
      >
        {customerInfo.name && <p>{customerInfo.name}</p>}
        {customerInfo.address && <p>{customerInfo.address}</p>}
        {customerInfo.email && <p>{customerInfo.email}</p>}
        {customerInfo.phone && <p>{customerInfo.phone}</p>}
      </CustomCard>
      <CustomCard
        title={
          <>
            <ContactDetailsIcon />
            People Details
          </>
        }
      >
        {customerInfo?.customerContacts?.sort((a, b) => {
          // Check if either a or b has the primaryContactId
          const aIsPrimary = a.id === contactId;
          const bIsPrimary = b.id === contactId;

          if (aIsPrimary && !bIsPrimary) {
            return -1; // a comes first
          } else if (!aIsPrimary && bIsPrimary) {
            return 1; // b comes first
          } else {
            return 0; // maintain the current order
          }
        }).map((contact, index) => (
          <div className="mb-2">
            <CustomCard
            key={index}
            bg="light"
            title={`${contact.firstName || ""} ${contact.lastName || ""}`}
            className="mb-0"
            >
            {
              contactId !== contact.id ? (
                <div>
                  <Button
                    onClick={(e) => handleUpdateTicketGroupContact(contact.id)}
                    style={{ float: 'right' }}
                  >
                    Set Contact
                  </Button>
                </div>
              )
              :
              (
                <div style={{ float: 'right' }}>Contact</div>
              )
            }
            {contact.customerContactEmails.map((item, index) => (
                <p key={index} className="mb-1">
                {item.email}
                </p>
            ))}
            {contact.customerContactPhoneNumbers.map((item, index) => (
                <p key={index} className="mb-1">
                {item.phone}
                </p>
            ))}
            
            </CustomCard>
          </div>
        ))}
      </CustomCard>
      {customerRules.length > 0 && (
        <CustomCard title="Customer Rules">
          {mainCustomerRules.map((customerRule) => (
            <Form.Group key={customerRule.id} className="mb-2">
              <Form.Check
                label={customerRule.name}
                checked={
                  !!customerRules.find(
                    (item) => customerRule.id === item.id
                  )
                }
                disabled
              />
            </Form.Group>
          ))}
        </CustomCard>
      )}
    </>
  );
};

export default Customer;
